import CellLink from '@/components/GokuDataGrid/CellLink'
import CellStatus, { Color } from '@/components/GokuDataGrid/CellStatus'
import CellDate from '@/components/GokuDataGrid/CellDate'
import { Promo } from '@/modules/Promo/types'
import { generatePathDatacentral, paths } from '@/utils/path'
import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'
import { Typogaphy } from 'vnetwork-ui'
import { TFunction } from 'i18next'
import {
    PROMO_STATUS_OPTIONS,
    PROMO_TYPE_OPTIONS,
} from '@/modules/Promo/constants'

const formatCurrency = (value: number, currency = 'VND') => {
    return new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency,
        maximumFractionDigits: 0,
    }).format(value)
}

export const promoListColumns = (t: TFunction): GridColDefVNW<Promo>[] => [
    {
        field: 'code',
        headerName: t('code'),
        sortable: true,
        renderCell: ({ row }) => (
            <CellLink
                to={generatePathDatacentral(paths.promoDetail, {
                    id: String(row?.promo_id),
                })}
            >
                <span className="font-mono">{row?.code}</span>
            </CellLink>
        ),
        width: 150,
    },
    {
        field: 'name',
        headerName: t('name'),
        sortable: true,
        renderCell: ({ row }) => <Typogaphy>{row?.name}</Typogaphy>,
        width: 200,
    },
    {
        field: 'promo_type',
        headerName: t('type'),
        sortable: false,
        renderCell: ({ row }) => {
            const type = PROMO_TYPE_OPTIONS(t)?.find(
                (item) => item?.value === row?.promo_type
            )
            return <Typogaphy>{type?.label || row?.promo_type}</Typogaphy>
        },
        width: 120,
    },
    {
        field: 'discount_value',
        headerName: t('discount'),
        sortable: false,
        renderCell: ({ row }) => (
            <Typogaphy className="font-semibold">
                {row?.promo_type === 'percentage'
                    ? `${row?.discount_value}%`
                    : formatCurrency(row?.discount_value, row?.currency)}
            </Typogaphy>
        ),
        width: 120,
    },
    {
        field: 'current_uses',
        headerName: t('uses'),
        sortable: false,
        renderCell: ({ row }) => (
            <Typogaphy>
                {row?.current_uses}
                {row?.max_uses ? ` / ${row?.max_uses}` : ''}
            </Typogaphy>
        ),
        width: 100,
    },
    {
        field: 'valid_until',
        headerName: t('valid_until'),
        sortable: false,
        renderCell: ({ row }) =>
            row?.valid_until ? <CellDate date={row?.valid_until} /> : '-',
        width: 150,
    },
    {
        field: 'referrer_name',
        headerName: t('affiliate'),
        sortable: false,
        renderCell: ({ row }) => (
            <Typogaphy>{row?.referrer_name || t('system')}</Typogaphy>
        ),
        width: 150,
    },
    {
        field: 'status',
        headerName: t('status'),
        sortable: true,
        renderCell: ({ row }) => {
            const status = PROMO_STATUS_OPTIONS(t)?.find(
                (item) => item?.value === row?.status
            )

            return (
                <CellStatus
                    label={status?.label || row?.status}
                    color={status?.color as Color}
                    className="capitalize min-w-[80px]"
                />
            )
        },
        width: 100,
    },
    {
        field: 'created_at',
        headerName: t('created_at'),
        sortable: true,
        renderCell: ({ row }) => <CellDate date={row?.created_at} />,
        width: 150,
    },
]
